import * as types from '../types';

export interface MenuState {
    open: boolean;
    activeItem?: string;
}

const initialState: MenuState = {
    open: false,
};

export default function menuReducer(state: MenuState = initialState, action): MenuState {
    switch (action.type) {
        case types.MENU_SET_ACTIVE:
            return {
                ...state,
                activeItem: action.activeItem,
            };
        case types.MENU_TOGGLE:
            return {
                ...state,
                open: action.open,
            };
        default:
            return state;
    }
}
